<template>
    <v-fade-transition hide-on-leave>
        <component v-bind:is="layout"></component>
    </v-fade-transition>
</template>

<script>
import AppLayout from '@/layouts/AppLayout'
import SimpleLayout from '@/layouts/SimpleLayout'

export default {
    components: {
        'app-layout': AppLayout,
        'simple-layout': SimpleLayout,
    },

    computed: {
        layout() {
            return this.$store.getters['layout/layout']
        },
    },
}
</script>
